import React, { useContext } from 'react'
import { defaultState, ChannelFeedResponse } from '../libs/fetchChannelFeed'
import useChannelFeed from '../libs/useChannelFeed'
import { EnvVariablesContext } from '../contexts/EnvVariablesContext'

export const ChannelFeedContext = React.createContext<ChannelFeedResponse>(defaultState)

const { Provider } = ChannelFeedContext

const ChannelFeedProvider = ({ value, children }) => {

  const { hostUrl  } = useContext(EnvVariablesContext)
  const { data } = useChannelFeed(value, hostUrl)

  return <Provider value={data}>{ children }</Provider>

}

export default ChannelFeedProvider
